var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82 5100 c-33 -15 -47 -29 -62 -62 -19 -42 -20 -88 -20 -2482 l0 -2438 22 -39 c14 -25 37 -46 63 -59 41 -20 56 -20 2486 -18 l2444 3 33 23 c91 65 81 205 -18 254 -33 17 -167 18 -2363 18 -1586 0 -2334 3 -2348 10 -19 10 -19 32 -19 965 l0 955 258 0 c231 0 261 2 292 19 50 27 73 62 78 123 3 44 0 59 -20 88 -45 67 -62 70 -350 70 l-258 0 0 130 0 130 163 0 c178 0 210 8 252 64 28 39 28 133 -1 173 -40 55 -72 63 -251 63 l-163 0 0 130 0 130 161 0 c180 0 212 8 252 64 30 42 31 132 1 173 -40 55 -72 63 -251 63 l-163 0 0 130 0 130 158 0 c144 0 162 2 202 23 57 29 83 75 77 140 -5 57 -30 95 -78 119 -28 15 -62 18 -196 18 l-163 0 0 130 0 130 253 0 c242 0 255 1 297 23 107 54 107 206 0 259 -31 16 -67 18 -292 18 l-258 0 0 112 c0 139 -18 185 -84 217 -52 26 -79 26 -134 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4083 4661 c-144 -122 -819 -749 -830 -771 -10 -19 -13 -97 -11 -327 l3 -303 33 -32 32 -33 165 -3 165 -4 0 -1289 0 -1289 540 0 540 0 0 1289 0 1289 163 4 c176 3 201 10 225 64 17 36 16 611 -1 641 -14 25 -828 766 -872 794 -51 32 -87 25 -152 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2204 2513 c-12 -2 -34 -18 -50 -34 l-29 -30 -3 -920 -2 -919 540 0 540 0 0 911 c0 821 -2 914 -16 938 -34 57 -21 56 -509 57 -247 1 -460 0 -471 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701 1886 c-51 -28 -50 -18 -51 -668 l0 -608 535 0 535 0 0 613 c0 565 -2 614 -18 633 -9 12 -27 27 -39 33 -34 17 -930 15 -962 -3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.b6691ee9383b03bffbe59de55cdd627f.svg";
export { ForwardRef as ReactComponent };